import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { LazyAxios, catchError, getToken, handleRequest, setToken } from '../base'
import { url } from "../base/Variables";

const baseUrl = `${url}/api/v1/user`

const initialState = {
    user_profile: null,
    user_loading: false,
    user_error: null,
    user_error_field: null,
    user_error_type: null,
    user_action: null,
    user_success: null
}

const createUser = createAsyncThunk('createUser', async (data, { rejectWithValue }) => {
    try {
        const axios = await LazyAxios()
        const request = await axios.post(`${baseUrl}/createUser/`, data)
        return handleRequest(request, rejectWithValue)
    }
    catch (error) {
        return rejectWithValue(catchError(error))
    }
})

const loginUser = createAsyncThunk('loginUser', async (data, { rejectWithValue }) => {
    try {
        const axios = await LazyAxios()
        const request = await axios.post(`${baseUrl}/loginUser/`, data)
        console.log(request)
        return handleRequest(request, rejectWithValue)

    }
    catch (error) {
        return rejectWithValue(catchError(error))
    }
})

const resetPassword = createAsyncThunk('resetPassword', async (data, { rejectWithValue }) => {
    try {
        const token = getToken()
        const axios = await LazyAxios()
        const request = await axios.put(`${baseUrl}/resetPassword/`, data, {
            headers: {
                Authorization: `Bearer ${token}`
            }
        })
        return handleRequest(request, rejectWithValue)
    }
    catch (error) {
        return rejectWithValue(catchError(error))
    }
})

const getuserProfile = createAsyncThunk('getuserProfile', async (_, { rejectWithValue }) => {
    try {
        const token = getToken()
        const axios = await LazyAxios()
        const request = await axios.get(`${baseUrl}/userProfile/`, {
            headers: {
                Authorization: `Bearer ${token}`
            }
        })
        return handleRequest(request, rejectWithValue)
    }
    catch (error) {
        return rejectWithValue(catchError(error))
    }
})

const updateuserProfile = createAsyncThunk('updateuserProfile', async (data, { rejectWithValue }) => {
    try {
        const token = getToken()
        const axios = await LazyAxios()
        const request = await axios.put(`${baseUrl}/userProfile/`, data, {
            headers: {
                Authorization: `Bearer ${token}`
            }
        })
        return handleRequest(request, rejectWithValue)
    }
    catch (error) {
        return rejectWithValue(catchError(error))
    }
})



const userSlice = createSlice({
    name: 'userSlice',
    initialState: initialState,
    reducers: {
        // set the complete slice to default
        userSliceDefault(state, action) {
            state.user_profile = null
            state.user_loading = false
            state.user_error = null
            state.user_error_type = null
            state.user_action = null
            state.user_success = null
            state.user_error_field = null
        },

        // after error or succes, set default
        setUserDefault(state, action) {
            state.user_error = null
            state.user_error_type = null
            state.user_action = null
            state.user_success = null
            state.user_error_field = null
        },
    },
    extraReducers: (builder) => {
        builder
            .addCase(createUser.pending, (state) => {
                state.user_loading = true
                state.user_error = null
                state.user_error_type = null
                state.user_success = null
                state.user_action = 'createUser'
                state.user_error_field = null
            })
            .addCase(createUser.fulfilled, (state, action) => {
                state.user_loading = false
                state.user_success = action.payload.success_message
                setToken(action.payload.access_token)
            })
            .addCase(createUser.rejected, (state, action) => {
                state.user_loading = false
                state.user_error_type = action.payload.type
                state.user_error = action.payload.error_message
                state.user_error_field = action.payload.error_field ? action.payload.error_field : null
            })

            .addCase(loginUser.pending, (state) => {
                state.user_loading = true
                state.user_error = null
                state.user_error_type = null
                state.user_success = null
                state.user_action = 'loginUser'
                state.user_error_field = null
            })
            .addCase(loginUser.fulfilled, (state, action) => {
                state.user_loading = false
                state.user_success = action.payload.success_message
                setToken(action.payload.access_token)
            })
            .addCase(loginUser.rejected, (state, action) => {
                state.user_loading = false
                state.user_error_type = action.payload.type
                state.user_error = action.payload.error_message
            })

            .addCase(resetPassword.pending, (state) => {
                state.user_loading = true
                state.user_error = null
                state.user_error_type = null
                state.user_success = null
                state.user_action = 'resetPassword'
                state.user_error_field = null
            })
            .addCase(resetPassword.fulfilled, (state, action) => {
                state.user_loading = false
                state.user_success = action.payload.success_message
            })
            .addCase(resetPassword.rejected, (state, action) => {
                state.user_loading = false
                state.user_error_type = action.payload.type
                state.user_error = action.payload.error_message
            })

            .addCase(getuserProfile.pending, (state) => {
                state.user_loading = true
                state.user_error = null
                state.user_error_type = null
                state.user_success = null
                state.user_error_field = null
            })
            .addCase(getuserProfile.fulfilled, (state, action) => {
                state.user_loading = false
                state.user_profile = action.payload.data
            })
            .addCase(getuserProfile.rejected, (state, action) => {
                state.user_error = action.payload.error_message
                state.user_error_type = action.payload.type
                state.user_loading = false
            })

            .addCase(updateuserProfile.pending, (state) => {
                state.user_loading = true
                state.user_error = null
                state.user_error_type = null
                state.user_error_field = null
                state.user_success = null
            })
            .addCase(updateuserProfile.fulfilled, (state, action) => {
                state.user_loading = false
                state.user_profile = { ...state.user_profile, ...action.payload.data }
                state.user_success = 'profile updated !'
            })
            .addCase(updateuserProfile.rejected, (state, action) => {
                state.user_error = action.payload.error_message
                state.user_error_type = action.payload.type
                state.user_loading = false
                state.user_error_field = action.payload.error_field ? action.payload.error_field : null
            })
    }
})

export default userSlice;
export { createUser, loginUser, resetPassword, getuserProfile, updateuserProfile };
export const { userSliceDefault, setUserDefault } = userSlice.actions
